/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EventColors {
    EVENT_COLOR_ONE = 0,
    EVENT_COLOR_TWO = 1,
    EVENT_COLOR_THREE = 2,
    EVENT_COLOR_FOUR = 3,
    EVENT_COLOR_FIVE = 4,
    EVENT_COLOR_SIX = 5,
    EVENT_COLOR_SEVEN = 6,
    EVENT_COLOR_EIGHT = 7,
}
